import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react-pro";
import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { confirmDeleteBox } from "src/actions/confirmDeleteBox";

const ConfirmDeleteModal = () => {
    const dispatch = useDispatch();
    const title = useSelector(state => state.confirmDeleteBox?.title);
    const confirmText = useSelector(state => state.confirmDeleteBox?.confirmText);
    const confirmLabel = useSelector(state => state.confirmDeleteBox?.confirmLabel);
    const onConfirm = useSelector(state => state.confirmDeleteBox?.onConfirm);
    const visible = useSelector(state => state.confirmDeleteBox?.visible);

    return (
        <>
            <CModal className="app-font" visible={visible} onClose={() => confirmDeleteBox.close(dispatch)} aria-labelledby='confirmModal'>
                <CModalHeader onClose={() => confirmDeleteBox.close(dispatch)}>
                    <CModalTitle id='confirmModal'>{title || 'Are you sure?'}</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <p>{confirmText}</p>
                </CModalBody>
                <CModalFooter>
                    <CButton className='outline-btn' onClick={() => confirmDeleteBox.close(dispatch)}>
                        Cancel
                    </CButton>
                    <CButton className='btn-delete' onClick={onConfirm}>{confirmLabel || 'Delete'}</CButton>
                </CModalFooter>
            </CModal>
        </>
    );
};

export default ConfirmDeleteModal;
